module.exports = __webpack_public_path__ + "img/gengxin3.6c62694e.png";